module.exports = {
	init: function () {
		window.PREBID_TIMEOUT = 600;
		let currencyAdjustment = 0.7451;
        try{
            (function () {
                let rate = window.config.prebid_cur_rate;

                if (rate > 0 && rate < 100) {
                    currencyAdjustment = rate;
                } else {
                    throw 'Rate is not valid number';
                }
            }());
        } catch (err) {
            console.warn('Error getting exchange rate, default rate used: ' + currencyAdjustment, err);
        }

        try {
            (function () {
                let timeout = window.config.prebid_timeout;

                if (timeout > 1 && timeout < 100000) {
                    window.PREBID_TIMEOUT = timeout;
                } else {
                    throw 'Prebid timeout is not valid number';
                }
            }());
        } catch (err) {
            console.warn('Error getting Prebid timeout, default timeout used: ' + window.PREBID_TIMEOUT, err);
        }

        if (window.location.href.indexOf('pbjs_debug=true') > -1) {
            console.log('USD/GBP rate is: ' + currencyAdjustment);
        }

		window.pbjs = window.pbjs || {};
		window.pbjs.que = window.pbjs.que || [];

		let calculateCurrency = function (bidCpm) {
		    return bidCpm * currencyAdjustment;
		};

        window.pbjs.que.push(function () {
            window.pbjs.setConfig({
                consentManagement: {
                    cmpApi: 'iab',
                    timeout: 8000,
                    allowAuctionWithoutConsent: true
                }
            });
        });

		window.pbjs.bidderSettings = {
		    standard: {
		        adserverTargeting: [
                    {
                        key: "hb_pb",
                        val: function (bidResponse) {
                            var cpm = bidResponse.cpm;

                            if (cpm < 1.00) {
                                return (Math.floor(cpm * 100) / 100).toFixed(2);
                            } else if (cpm < 6.00) {
                                return (Math.floor(cpm * 10) / 10).toFixed(1);
                            } else if (cpm < 50.00) {
                                return (cpm).toFixed();
                            } else {
                                return '50';
                            }
                        }
                    },{
                        key: "hb_adid",
                        val: function (bidResponse) {
                            return bidResponse.adId;
                        }
                    },{
                        key: "hb_bidder",
                        val: function (bidResponse) {
                            return bidResponse.bidderCode;
                        }
                    },{
                        key: "hb_size",
                        val: function (bidResponse) {
                            return bidResponse.size;
                        }
                    }
		        ]
		    },
		    /*brealtime: {
		        bidCpmAdjustment : function (bidCpm) {
		            // adjust the bid in real time before the auction takes place
		            return bidCpm * .8 * currencyAdjustment;
		        }
		    },*/
		    c1x: {
                pixelId: 1234804,
                siteId: 13255,
                adserverTargeting: [
                    {
                        key: "hb_pb",
                        val: function (bidResponse) {
                            var cpm = bidResponse.cpm;

                            if (cpm < 1.00) {
                                return (Math.floor(cpm * 100) / 100).toFixed(2);
                            } else if (cpm < 6.00) {
                                return (Math.floor(cpm * 10) / 10).toFixed(1);
                            } else if (cpm < 50.00) {
                                return (cpm).toFixed();
                            } else {
                                return '50';
                            }
                        }
                    },{
                        key: "hb_adid",
                        val: function (bidResponse) {
                            return bidResponse.adId;
                        }
                    },{
                        key: "hb_bidder",
                        val: function (bidResponse) {
                            return bidResponse.bidderCode;
                        }
                    },{
                        key: "hb_size",
                        val: function (bidResponse) {
                            return bidResponse.size;
                        }
                    }
		        ],
		        bidCpmAdjustment: calculateCurrency
		    },
			pulsepointLite: {bidCpmAdjustment: calculateCurrency},
            /*districtmDMX: {bidCpmAdjustment: calculateCurrency},*/
            defymedia: {bidCpmAdjustment: calculateCurrency},
            ix: {bidCpmAdjustment: calculateCurrency},
            appnexus: {bidCpmAdjustment: calculateCurrency},
            smartadserver: {
                bidCpmAdjustment: function(bidCpm) {
                    // adjust the bid in real time before the auction takes place
                    return bidCpm * .75 * currencyAdjustment;
                }
            },
            sharethrough: {bidCpmAdjustment: calculateCurrency},
            sovrn: {bidCpmAdjustment: calculateCurrency},
            openx: {
                bidCpmAdjustment: function(bidCpm) {
                    // adjust the bid in real time before the auction takes place
                    return bidCpm * .7 * currencyAdjustment;
                }
            },
            improvedigital: {
                bidCpmAdjustment: function (bidCpm) {
                    // adjust the bid in real time before the auction takes place
                    return bidCpm * .9 * currencyAdjustment;
                }
            }
		};

        let script = document.createElement('script');
        script.src = '/wp-content/plugins/fp-pause-helper/assets/js/prebid.js?ver=v1.12.0u2018-05-23';
        script.async = true;
        let placeToInsert = document.querySelector('script');
        placeToInsert.parentNode.insertBefore(script, placeToInsert);
	}
}